export default "__VITE_ASSET__D5lJ6i6b__"